import { useEffect, useState } from 'react'

import { stepsItemsShop } from '@/screens/Credit/page/data'

import StepList from '@/screensComponents/FinancialServices/StepList/StepList'

import { BasketIPort } from '@/shared/lib/@deprecated/iport-icons'

import CheckBox from '../Checkbox/CheckBox'

import cl from './CreditGetEasy.module.scss'

export enum ViewTable {
	Online = `online`,
	Offline = `offline`
}

export type TypeShop = { icon: typeof BasketIPort; title: string; subtitle: string }[]

const CreditGetEasy = () => {
	const [viewTable, setViewTable] = useState<string>(ViewTable.Online)
	const [contentData, setContentData] = useState<TypeShop>(stepsItemsShop.online)

	useEffect(() => {
		setContentData(viewTable === ViewTable.Online ? stepsItemsShop.online : stepsItemsShop.offline)
	}, [viewTable])

	return (
		<section className={cl.creditGetEasy}>
			<h2 className={cl.creditGetEasy__title}>Оформить рассрочку и кредит — легко</h2>
			<div className={cl.creditGetEasy__content}>
				<CheckBox
					items={[
						{ title: `На сайте`, value: ViewTable.Online },
						{ title: `В магазине`, value: ViewTable.Offline }
					]}
					changeHandler={setViewTable}
				/>
				<StepList itemList={contentData} />
			</div>
		</section>
	)
}

export default CreditGetEasy
